export default __webpack_public_path__ + "static/media/1v1_diamond_bg.fbf2cabe.png";